module.exports = __webpack_public_path__ + "static/media/C23.9ed24a63.png";